import React from 'react';
import Button from '../ui/Button';
import Input from '../ui/Input';

const ContractDetailsForm = ({ template, details, onChange, onSubmit, onBack, loading }) => {
  // Group fields by section (optional - for better organization)
  const groupFieldsBySection = (fields) => {
    // This is a simple implementation - in a real app, you might have more complex grouping logic
    const sections = {
      'Party Information': fields.filter(f => 
        f.id.includes('party') || 
        f.id.includes('client') || 
        f.id.includes('provider') ||
        f.id.includes('employer') ||
        f.id.includes('employee') ||
        f.id.includes('seller') ||
        f.id.includes('buyer') ||
        f.id.includes('landlord') ||
        f.id.includes('tenant')
      ),
      'Contract Details': fields.filter(f => 
        !f.id.includes('party') && 
        !f.id.includes('client') && 
        !f.id.includes('provider') &&
        !f.id.includes('employer') &&
        !f.id.includes('employee') &&
        !f.id.includes('seller') &&
        !f.id.includes('buyer') &&
        !f.id.includes('landlord') &&
        !f.id.includes('tenant')
      )
    };
    
    return sections;
  };
  
  // Render a form field based on its type
  const renderField = (field) => {
    const value = details[field.id] || '';
    
    switch (field.type) {
      case 'textarea':
        return (
          <div key={field.id} className="form-field" style={{ gridColumn: '1 / span 2' }}>
            <Input
              label={field.label}
              type="textarea"
              id={field.id}
              value={value}
              onChange={(e) => onChange(field.id, e.target.value)}
              required={field.required}
            />
          </div>
        );
        
      case 'date':
        return (
          <div key={field.id} className="form-field">
            <Input
              label={field.label}
              type="date"
              id={field.id}
              value={value}
              onChange={(e) => onChange(field.id, e.target.value)}
              required={field.required}
            />
          </div>
        );
        
      case 'number':
        return (
          <div key={field.id} className="form-field">
            <Input
              label={field.label}
              type="number"
              id={field.id}
              value={value}
              onChange={(e) => onChange(field.id, e.target.value)}
              required={field.required}
            />
          </div>
        );
        
      default: // text
        return (
          <div key={field.id} className="form-field">
            <Input
              label={field.label}
              type="text"
              id={field.id}
              value={value}
              onChange={(e) => onChange(field.id, e.target.value)}
              required={field.required}
            />
          </div>
        );
    }
  };
  
  if (!template || !template.form_schema) {
    return (
      <div className="contract-details-form">
        <h2>Enter Contract Details</h2>
        <p>Template schema not found. Please go back and select a different template.</p>
        <div className="form-actions">
          <Button onClick={onBack} variant="secondary">
            Back
          </Button>
        </div>
      </div>
    );
  }
  
  const fields = template.form_schema.fields || [];
  const sections = groupFieldsBySection(fields);
  
  return (
    <div className="contract-details-form">
      <h2>Enter Contract Details</h2>
      <p>Fill in the details for your {template.name}. All required fields must be completed.</p>
      
      <form onSubmit={onSubmit} className="contract-form">
        {Object.entries(sections).map(([sectionName, sectionFields]) => (
          sectionFields.length > 0 && (
            <div key={sectionName} className="form-section">
              <h3 className="form-section-title">{sectionName}</h3>
              <div className="form-grid">
                {sectionFields.map(field => renderField(field))}
              </div>
            </div>
          )
        ))}
        
        <div className="form-actions">
          <Button 
            type="button" 
            onClick={onBack} 
            variant="secondary"
            disabled={loading}
          >
            Back
          </Button>
          <Button 
            type="submit" 
            disabled={loading}
          >
            {loading ? 'Generating...' : 'Generate Contract'}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default ContractDetailsForm;
